import { useQuery } from "react-query";
import { getActiveFranchiseEmployeeCount } from "../../../../../actions/Employees";

const useGetActiveFranchiseEmployeeCount = () => {
  return useQuery(
    "GetActiveFranchiseEmployeeCount",
    getActiveFranchiseEmployeeCount,
    {
      refetchOnWindowFocus: false,
    }
  );
};

export default useGetActiveFranchiseEmployeeCount;
